<template>
  <li class="flex flex-col mb-2 relative card" role="none">
    <a
      ref="link"
      :href="url"
      role="menuitem"
      class="cover-link zoom block pt-1 font-heading font-bold text-sm nav__menu-item hover:underline order-2"
      tabindex="-1"
      :qaid="qaid"
      @keydown.prevent.right="rightFunction"
      @keydown.prevent.left="leftFunction"
      @keydown.prevent.down="downFunction"
      @keydown.prevent.up="upFunction"
    >
      <span v-html="label"></span>
    </a>
    <p class="text-xs order-3" v-html="description"></p>
    <picture class="aspect-[5/3] relative overflow-hidden order-1">
      <img :data-nav-image="imageAsset" :alt="label" class="absolute object-cover w-full h-full" loading="lazy" />
    </picture>
  </li>
</template>
<script>
import {Cloudinary, CloudinaryConstants} from '@/utils/image/cloudinary-helpers.js';
export default {
  name: 'NavAccessoryCard',
  props: {
    label: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    rightFunction: {
      type: Function,
      default: () => {},
    },
    leftFunction: {
      type: Function,
      default: () => {},
    },
    upFunction: {
      type: Function,
      default: () => {},
    },
    downFunction: {
      type: Function,
      default: () => {},
    },
    qaid: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    imageAsset() {
      const imageTransforms = {
        q: 'auto',
        w: 406,
        dpr: `${window.devicePixelRatio}`,
        ...CloudinaryConstants.DEFAULT_PARAMETERS,
      };
      return this.image ? Cloudinary.createAssetUrl(this.image, imageTransforms) : '';
    },
  },
};
</script>
<style lang="scss" scoped>
.cover-link {
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
  }

  @media (hover: hover) {
    &:hover {
      &.zoom ~ picture img {
        scale: 1.06;
      }
    }
  }
}

.zoom ~ picture img {
  transition: scale var(--nav-reduced-motion, 0.2s) ease-out;
  scale: 1;
}
</style>
